// Breakpoint values in pixels
export const breakpoints = {
  xs: 320,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536
} as const;

// Media query strings for use with CSS-in-JS
export const mediaQueries = {
  xs: `@media (min-width: ${breakpoints.xs}px)`,
  sm: `@media (min-width: ${breakpoints.sm}px)`,
  md: `@media (min-width: ${breakpoints.md}px)`,
  lg: `@media (min-width: ${breakpoints.lg}px)`,
  xl: `@media (min-width: ${breakpoints.xl}px)`,
  '2xl': `@media (min-width: ${breakpoints['2xl']}px)`,
  // Special cases
  hover: '@media (hover: hover)',
  dark: '@media (prefers-color-scheme: dark)',
  light: '@media (prefers-color-scheme: light)',
  portrait: '@media (orientation: portrait)',
  landscape: '@media (orientation: landscape)'
};

// Touch target minimum sizes
export const touchTargets = {
  min: 44, // Minimum size in pixels for touch targets
  comfortable: 48 // Comfortable size for touch targets
};

// Spacing scale for consistent responsive spacing
export const spacing = {
  xs: '0.25rem',
  sm: '0.5rem',
  md: '1rem',
  lg: '1.5rem',
  xl: '2rem',
  '2xl': '3rem'
};

// Font sizes that scale with viewport
export const fluidFontSizes = {
  xs: 'clamp(0.75rem, 0.7rem + 0.25vw, 0.875rem)',
  sm: 'clamp(0.875rem, 0.8rem + 0.375vw, 1rem)',
  base: 'clamp(1rem, 0.9rem + 0.5vw, 1.125rem)',
  lg: 'clamp(1.125rem, 1rem + 0.625vw, 1.25rem)',
  xl: 'clamp(1.25rem, 1.1rem + 0.75vw, 1.5rem)',
  '2xl': 'clamp(1.5rem, 1.3rem + 1vw, 2rem)',
  '3xl': 'clamp(1.875rem, 1.6rem + 1.375vw, 2.5rem)'
};

// Container max widths
export const containers = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
  '2xl': '1536px'
};

// Grid configurations
export const grid = {
  columns: {
    sm: 4,
    md: 8,
    lg: 12
  },
  gap: {
    sm: '1rem',
    md: '1.5rem',
    lg: '2rem'
  }
};

// Helper functions
export const isMobile = () => window.innerWidth < breakpoints.md;
export const isTablet = () => window.innerWidth >= breakpoints.md && window.innerWidth < breakpoints.lg;
export const isDesktop = () => window.innerWidth >= breakpoints.lg;